/** Sharing links (game invites, replays): the share sheet on touch screens, else the clipboard. */

export type ShareResult = 'shared' | 'copied' | 'failed';

export async function shareLink(url: string, title: string): Promise<ShareResult> {
  const touch = window.matchMedia('(pointer: coarse)').matches;
  if (touch && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, url });
      return 'shared';
    } catch (err) {
      // Closing the share sheet isn't a failure; anything else falls back to copying.
      if (err instanceof DOMException && err.name === 'AbortError') return 'shared';
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch {
    return 'failed';
  }
}

/** A path on this site as a full link. */
export const siteLink = (path: string) => `${location.origin}${path}`;
